import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request';

export type UseSendMagicLinkSuccessResponse =
    Api.Response.Success<Api.Response.Template.SuccessBasicMessage>;

export type UseSendMagicLinkErrorResponse = Api.Response.Failure<'message'>;

export type UseSendMagicLinkProps = {
    email: string;
    next?: string;
    remember?: boolean;
    session_minutes?: number;
};

export const useSendMagicLink = (): UseMutationResult<
    UseSendMagicLinkSuccessResponse,
    UseSendMagicLinkErrorResponse,
    UseSendMagicLinkProps
> => {
    const locale = useLocale();

    return useMutation(({email, next, remember, session_minutes}) =>
        request({
            formData: {email, next, remember, session_minutes},
            locale,
            method: 'POST',
            uri: '/portal/login/request/',
        }),
    );
};
